import { get, find, includes } from 'lodash';
import React from 'react';

import { i18n } from '@lt/localization';

import type { IFilter } from '../types';
import RadioFilterGroup from '../components/RadioFilterGroup';
import { getMinPrice, getHotelsCount } from '../../../utils/filtersUtils';

const WIFI_TYPES = {
  FREE: ['free', 'has'],
  LOBBY_FREE: ['free', 'has'],
  LOBBY_PAID: ['has'],
  LOBBY_UNKNOWN: ['has'],
  PAID: ['has'],
};

const FILTERS = [
  { id: 'nofilter', name: i18n.t('filters.Wifi.all_hotel') },
  { id: 'has', name: i18n.t('filters.Wifi.has') },
  { id: 'free', name: i18n.t('filters.Wifi.free') },
];

const FilterWiFi = ({
  data,
  onChange,
  onClear,
  className = '',
  isMobile = false,
  currencyCode,
}: IFilter): JSX.Element => {
  const allDisabled = data.every((item) => item.disabled);

  const makeFilterItem = (filterItem) => {
    const isChanged = data.some((item) => item.selected);
    const isFree = isFreeWifi(data);
    let selected: boolean;
    let disabled: boolean;
    let items;

    const { id: filterType } = filterItem;

    switch (filterType) {
      case 'has':
      case 'free':
        selected =
          isChanged && (isFree ? filterType === 'free' : filterType === 'has');
        items = data.filter((item) =>
          includes(WIFI_TYPES[item.id], filterType),
        );
        disabled = items.every((item) => item.disabled);
        break;
      default:
        selected = !isChanged;
        disabled = false;
        items = data;
    }

    return {
      ...filterItem,
      selected,
      disabled: allDisabled || disabled,
      hotel_count: getHotelsCount(items),
      min_price: getMinPrice(items),
      currencyCode,
    };
  };

  const handleChange = ({ id: value }) => {
    const path = filterName;

    const diff = data.map((item) => {
      const types = WIFI_TYPES[item.id] || [];
      const selected = types.includes(value);
      return { ...item, selected };
    });
    onChange({ path, diff });
  };

  const filters = FILTERS.map(makeFilterItem);
  const selected = get(
    find(filters, (item) => item.selected),
    'id',
  );
  const isChanged = selected && selected !== 'nofilter';

  return (
    <RadioFilterGroup
      className={className}
      data={filters}
      Filter={FilterWiFi}
      onChange={handleChange}
      onClear={onClear}
      showClearBtn={isChanged}
      isMobile={isMobile}
    />
  );
};

const filterName = 'wifi';

const isFreeWifi = (data) =>
  data
    .filter((item) => item.selected)
    .every((item) => includes(WIFI_TYPES[item.id], 'free'));

export default Object.assign(FilterWiFi, {
  filterName,
  filterLabel: 'Wi-Fi',
  isFreeWifi,
  valuesLabel: (data) =>
    FILTERS.find((filter) => filter.id === (isFreeWifi(data) ? 'free' : 'has'))
      ?.name,
});
